export enum UserType {
  Corporate = 'Corporate',
  Partner = 'Partner',
  Dealer = 'Dealer',
  Submitter = 'Submitter',
  Customer = 'Customer',
  PartnerAPI = 'PartnerAPI',
  Investor = 'Investor',
  IVR = 'IVR',
}
